import axios from 'axios'
// export default function (options, callback1, vueCompent) {
//   if (options.url.indexOf('login') === -1) {
//     let userToken = localStorage.getItem('token')
//     let userUuid = localStorage.getItem('uuid')
//     let userUid = localStorage.getItem('uid')
//     options.headers.token = userToken
//     options.headers.uid = userUid
//     options.headers.uuid = userUuid
//   }
//   axios(options).then((response) => {
//     if (response.data.success === '111111') {
//       vueCompent.openmessage('当前登陆已过期，请重新登陆')
//       setTimeout(function () {
//         vueCompent.$router.push({path: '/login'})
//       }, 2000)
//     } else {
//       callback1 && callback1(response)
//     }
//   }).catch((error) => {
//     console.log(error)
//   })
// }
export default function (options, callback1, vueCompent) {
  // if (options.url.indexOf('login') === -1) {
  //   let userToken = localStorage.getItem('token')
  //   let userUuid = localStorage.getItem('uuid')
  //   let userUid = localStorage.getItem('uid')
  //   options.headers.token = userToken
  //   options.headers.uid = userUid
  //   options.headers.uuid = userUuid
  // }
  axios(options).then((response) => {
    callback1 && callback1(response)
  }).catch((error) => {
    console.log(error)
  })
}



//////////////////
// WEBPACK FOOTER
// ./static/callApi.js
// module id = null
// module chunks = 